"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDevicesOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M16 11a1 1 0 00-1 1v8a1 1 0 001 1h4a1 1 0 001-1v-8a1 1 0 00-1-1h-4zm1.5 8a.5.5 0 000 1h1a.5.5 0 000-1h-1z' }),
    react_1.default.createElement("path", { d: 'M3.75 2.039A1.75 1.75 0 002 3.789V16.25c0 .967.784 1.75 1.75 1.75h5.21l-1.024 2.038H7a1 1 0 100 2h6.799a2.99 2.99 0 01-.799-2h-2.825L11.197 18H13v-2H4V4.04h16V9c.768 0 1.47.289 2 .764V3.789a1.75 1.75 0 00-1.75-1.75H3.75z' }),
    react_1.default.createElement("path", { d: 'M21 17.832V12a1 1 0 00-1-1v5h-5v2h5.25c.268 0 .523-.06.75-.168zM15 20.038A.998.998 0 0016 21h2a1 1 0 00-1-.962h-2z' }))); };
exports.default = SvgDevicesOutline;
//# sourceMappingURL=DevicesOutline.js.map